define('views/modules/calendar/animated-session/tags/manager/custom-tags-manager-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Services
    'services/i18n',
    // Events
    'services/layout',
    // collections
    'collections/calendar/session/tags',
    // Views
    'views/parts/list/fetch-list',
    'views/modules/calendar/animated-session/tags/manager/list/custom-tag-list-item',
    'views/parts/menu/menu-action',
    'views/modules/calendar/animated-session/tags/manager/edit/tag-edit-panel',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/tags/tags-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // Services
    i18n,
    // events
    LayoutState,
    // collections
    CTags,
    // Views
    VFetchList,
    VCustomTagListItem,
    VMenuAction,
    VTagEditPanel,
    // Template
    TTagsContent
) {

    var VCustomTagsManagerContent = Backbone.View.extend({
        template: TTagsContent,
        regions: {
            root: '#tags-content',
            menu: ".menu-actions",
            add: {
                elem: "#add-custom-tag",
                form: "#add-custom-tag-form",
            },
            list: "#custom-tags-list",
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.group = this.options.group;

            var collection = this.collection = new CTags(null, {
                custom: true,
                group: this.group.id
            });

            this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    radio: false,
                    collection: new Backbone.Collection([
                        { title: i18n.t('messages:tooltip-add-custom-tag'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddCustomTagAction }
                    ]),
                    tooltip: { container: this.regions.root, }
                }),

                list: new VFetchList({
                    collection: collection,
                    item: VCustomTagListItem,
                    button: {
                        label: 'calendar:Show more custom tags'
                    },
                    bottom: true
                }),
            };

            this.panel = {};

            this.listenTo(collection, { "tag:click": this.onTagClick });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list);

            this.collection.getFirstPage();

            return this;
        },

        lazyInit: function() {
            var view = this.panel.edit;
            if (!view) {
                view = this.panel.edit = new VTagEditPanel({ group: this.group });
                this.listenTo(view, 'form:success', this.onTagUpdate);
            }
            return view;
        },

        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddCustomTagAction: function() {
            var panel = this.lazyInit();
            panel.resetModel();
            LayoutState.setInfo(panel, { open: true, full: true });
        },

        onTagClick: function(model) {
            var panel = this.lazyInit();
            panel.setModel(model);
            LayoutState.setInfo(panel, { open: true, full: true });
        },

        onTagUpdate: function(model) {
            this.collection.set(model, { remove: false });
        },

    });

    return VCustomTagsManagerContent;

});

